import { ImageURLs } from 'interfaces/media'

/*
32 - avatar, for retina 64
80 - poster of fetched link, for comments, for retina 160
355 - poster of fetched link, most iphones size, for retina 710
540 - poster of fetched link, desktop, for retina 1080
*/

export const findImage = (image: ImageURLs, width: number) => {
  const naturalWidth = width * (window.devicePixelRatio || 1)
  const imagesFromBiggest = [...image.sources].reverse()
  const foundIndex = imagesFromBiggest.findIndex((imageSource) => imageSource.width < naturalWidth)

  if (foundIndex === -1) {
    // if there is no image with resolutiom lower than the required, chose an image with the lowest one
    return imagesFromBiggest[imagesFromBiggest.length - 1]
  }
  if (foundIndex === 0) {
    return imagesFromBiggest[0]
  }

  // use an image with a better quality then an image found
  const imageSourceForResolution = imagesFromBiggest[foundIndex - 1]

  return imageSourceForResolution
}

export const getFirstUrl = (image: ImageURLs) => image.sources[0].url

export const makeImage = (url: string, width: number, height: number, id = 1) => ({
  id,
  sources: [
    {
      url,
      width,
      height,
    },
  ],
})

export const getSvgByFilename = (filename: string) => {
  if (!filename) {
    return null
  }

  try {
    const matchingIcon = require(`icons/${ filename }.svg`)
    return matchingIcon.default
  } catch (ex) {
    return null
  }
}
